/** Existing master choices and explicit frozen classification outrank defaults. */
export function importStorageDefault(category: string, extracted: string | null | undefined, existing: string | null | undefined): string {
  if (existing) return existing;
  if (extracted === 'surgelato') return extracted;
  return category === 'salumi' ? 'fresco' : extracted || 'fresco';
}
export function remembersImportSkip(line: { skip: boolean; skip_once?: boolean }): boolean {
  return line.skip && !line.skip_once;
}
